<li class="nav-item ">
  <a class="nav-link" [attr.data-test-id]="'tab-'+tab.title" [ngClass]='{active: tab.active}' (click)="selectTab(tab)">{{tab.title}}</a>
</li>
